
import ClientHead from "@/components/main/core/ClientHead"
import FeedBackContacts from "@/components/main/forms/FeedBackContacts"
import RedSection from "@/components/main/core/RedSection"
import CheckBox from "@/components/main/core/CheckBox"
import Label from "@/components/main/core/Label"
import feedBackIssueOptions from "@/mixins/data"

export default {

  head() {
    const title = 'Reach Out to Us - Easy & Friendly Support | iFindCheaters';
    const description = 'Have questions? We\'re here to help - Connect with our friendly support team at iFindCheaters for all your inquiries. Get in touch today and let us assist you.';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Look Up Cheaters Online, Cheating Online, Catch a Cheating Partner Online, websites for catching cheaters, Best Cheater Lookup Websites, catch cheating spouse, hidden profile finder, find hidden dating profiles, verify spouse online, online infidelity search, detect cheating partner, find spouse on dating sites, catch cheating partner'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/contact/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Contact Us",
            }],
          }
        }
      ]
    };
  },

  name: "Contact",
  layout: 'clientLayout',
  mixins: [feedBackIssueOptions],
  components: { FeedBackContacts, ClientHead, Label, RedSection, CheckBox },
  data() {
    return {
      isAccepted: false,
    }
  },
  computed: {},
  mounted() {
    this.isAccepted = false;
  },
  methods: {
    accept() {
      this.isAccepted = !this.isAccepted
    },
    getEncodedEmail(email) {
      const encodedEmail = encodeURIComponent(email);
      return `mailto:${encodedEmail}`;
    },
  }
}
